import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Header from "./Header";
import AddServicePopup from "./AddServicePopup";
import AddCategoryPopup from "./AddCategoryPopup";
import EditServicePopup from "./EditServicePopup";
import { Helmet } from "react-helmet";
import config from "../../config";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from "@mui/material/CircularProgress";
import VertNav from "./VertNav";
import AddComboPopup from "./AddComboPopup.jsx"; 

function ServiceDetails() {
  const [isAddPopupOpen, setIsAddPopupOpen] = useState(false);
  const [isAddPopupOpen2, setIsAddPopupOpen2] = useState(false);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editServiceData, setEditServiceData] = useState(null);
  const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false);
  const [serviceToDelete, setServiceToDelete] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteType, setDeleteType] = useState(""); // 'service' or 'combo'
  const hasFetched = useRef(false);
  const bid = localStorage.getItem("branch_id");
  const [isAddComboOpen, setIsAddComboOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${config.apiUrl}/api/swalook/table/services/?branch_name=${bid}`,
          {
            headers: {
              Authorization: `Token ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        setServiceData(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (!hasFetched.current) fetchData();
  }, [bid]);

  const AddtogglePopup = () => setIsAddPopupOpen((prev) => !prev);
  const AddtogglePopup2 = () => setIsAddPopupOpen2((prev) => !prev);
  const AddComboToggle = () => setIsAddComboOpen((prev) => !prev);

  const EdittogglePopup = (
    id,
    serviceName,
    serviceDuration,
    servicePrice,
    category
  ) => {
    setIsEditPopupOpen((prev) => !prev);
    setEditServiceData({
      id,
      serviceName,
      serviceDuration,
      servicePrice,
      category,
    });
  };

  const handleDeleteService = async () => {
    if (!serviceToDelete) return;

    const token = localStorage.getItem("token");
    try {
      if (deleteType === 'service') {
        await axios.delete(
          `${config.apiUrl}/api/swalook/delete/services/?id=${serviceToDelete.id}`,
          {
            headers: {
              Authorization: `Token ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      } else if (deleteType === 'combo') {
        // Implement combo deletion API call here
        console.log("Delete combo:", serviceToDelete.combo_name);
      }

      // Refresh data after deletion
      const response = await axios.get(
        `${config.apiUrl}/api/swalook/table/services/?branch_name=${bid}`,
        {
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      
      setServiceData(response.data.data);
      setIsDeleteConfirmationOpen(false);
    } catch (error) {
      console.error("Error deleting:", error);
    }
  };

  // Filter function for both services and combos
  const filterData = (data) => {
    if (!searchQuery) return data;
    
    return data.filter(item => {
      // For categories with services
      if (item.services) {
        return item.category_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
               item.services.some(service => 
                 service.service.toLowerCase().includes(searchQuery.toLowerCase())
               );
      }
      // For categories with combos
      if (item.combos) {
        return item.category_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
               item.combos.some(combo => 
                 combo.combo_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                 combo.services.some(service => 
                   service.service.toLowerCase().includes(searchQuery.toLowerCase())
                 )
               );
      }
      return false;
    });
  };

  return (
    <>
      <Header />
      <VertNav />
      <div className="md:ml-72 p-10">
        <Helmet>
          <title>Services</title>
        </Helmet>
        {/* Add Service, Add Category, and Search Bar */}
        <div className="flex flex-wrap justify-between items-center my-6">
          <h1 className="text-2xl font-bold text-gray-700">Service Details</h1>
          <div className="flex flex-row items-center justify-end space-x-4">
            <input
              type="text"
              className="border border-gray-300 rounded-md items-center mx-2 px-4 py-2 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
              placeholder="Search services, combos or categories"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button
              className="bg-indigo-500 text-white items-center mb-4 my-6 px-4 py-2 rounded-md hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              onClick={AddtogglePopup2}
            >
              Add Category
            </button>
            <button
              className="bg-indigo-500 text-white items-center mb-4 my-6 px-4 py-2 rounded-md hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              onClick={AddtogglePopup}
            >
              Add Service
            </button>
            <button
              className="bg-indigo-500 text-white items-center mb-4 my-6 px-4 py-2 rounded-md hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              onClick={AddComboToggle}
            >
              Add Combo
            </button>
          </div>
        </div>

        {/* Display tables for each category */}
        {loading ? (
          <div className="text-center py-6">
            <CircularProgress />
          </div>
        ) : (
          filterData(serviceData).map((category) => (
            <div key={category.category_name} className="mb-8">
              <div className="overflow-x-auto">
                <table className="w-full justify-between bg-white rounded-lg shadow-md">
                  <thead className="py-3 px-4 text-left text-xl font-bold text-gray-700 mb-4">
                    <th>{category.category_name}</th>
                  </thead>
                  
                  {/* Services Table */}
                  {category.services && category.services.length > 0 && (
                    <>
                      <thead className="bg-gray-100 text-gray-600 text-sm">
                        <tr>
                          <th className="py-3 px-4 text-left">Service Name</th>
                          <th className="py-3 px-4 text-left">Duration</th>
                          <th className="py-3 px-4 text-left">Price</th>
                          <th className="py-3 px-4 text-left">For Men</th>
                          <th className="py-3 px-4 text-left">For Women</th>
                          <th className="py-3 px-4 text-center">Edit</th>
                          <th className="py-3 px-4 text-center">Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {category.services
                          .sort((a, b) => a.service_price - b.service_price)
                          .map((service) => (
                            <tr
                              key={service.id}
                              className="hover:bg-gray-50 border-b border-gray-200"
                            >
                              <td className="py-3 px-4">{service.service}</td>
                              <td className="py-3 px-4">
                                {service.service_duration} min
                              </td>
                              <td className="py-3 px-4">
                                Rs. {service.service_price}
                              </td>
                              <td className="py-3 px-4">
                                {service.for_men ? "Yes" : "No"}
                              </td>
                              <td className="py-3 px-4">
                                {service.for_women ? "Yes" : "No"}
                              </td>
                              <td className="py-3 px-4 text-center">
                                <EditIcon
                                  onClick={() =>
                                    EdittogglePopup(
                                      service.id,
                                      service.service,
                                      service.service_duration,
                                      service.service_price,
                                      category.category_name
                                    )
                                  }
                                  className="text-indigo-500 cursor-pointer"
                                />
                              </td>
                              <td className="py-3 px-4 text-center">
                                <DeleteIcon
                                  onClick={() => {
                                    setServiceToDelete(service);
                                    setDeleteType("service");
                                    setIsDeleteConfirmationOpen(true);
                                  }}
                                  className="text-red-500 cursor-pointer"
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </>
                  )}
                  
                  {/* Combos Table */}
                  {category.combos && category.combos.length > 0 && (
                    <>
                      <thead className="bg-gray-100 text-gray-600 text-sm mt-6">
                        <tr>
                          {/* <th colSpan="7" className="py-3 px-4 text-center bg-blue-50">
                            Combos
                          </th> */}
                        </tr>
                        <tr>
                          <th className="py-3 px-4 text-left">Combo Name</th>
                          <th className="py-3 px-4 text-left">Total Duration</th>
                          <th className="py-3 px-4 text-left">Combo Price</th>
                          <th className="py-3 px-4 text-left" colSpan="2">Services Included</th>
                          <th className="py-3 px-4 text-center">Edit</th>
                          <th className="py-3 px-4 text-center">Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {category.combos.map((combo) => (
                          <tr
                            key={combo.combo_name}
                            className="hover:bg-gray-50 border-b border-gray-200"
                          >
                            <td className="py-3 px-4 font-medium">{combo.combo_name}</td>
                            <td className="py-3 px-4">
                              {combo.duration} min
                            </td>
                            <td className="py-3 px-4">
                              Rs. {combo.combo_price}
                            </td>
                            <td className="py-3 px-4" colSpan="2">
                              <ul className="list-disc list-inside">
                                {combo.services.map((service, index) => (
                                  <li key={index}>
                                    {service.service} ({service.category})
                                  </li>
                                ))}
                              </ul>
                            </td>
                            <td className="py-3 px-4 text-center">
                              <EditIcon
                                className="text-indigo-500 cursor-pointer"
                                onClick={() => {
                                  // Implement combo edit functionality
                                  console.log("Edit combo:", combo.combo_name);
                                }}
                              />
                            </td>
                            <td className="py-3 px-4 text-center">
                              <DeleteIcon
                                onClick={() => {
                                  setServiceToDelete(combo);
                                  setDeleteType("combo");
                                  setIsDeleteConfirmationOpen(true);
                                }}
                                className="text-red-500 cursor-pointer"
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </>
                  )}
                </table>
              </div>
            </div>
          ))
        )}

        {/* Delete confirmation modal */}
        {isDeleteConfirmationOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
              <h3 className="text-lg font-bold text-gray-700 mb-4">
                Are you sure you want to delete this {deleteType}?
              </h3>
              <div className="flex justify-end">
                <button
                  className="mr-2 text-gray-500"
                  onClick={() => setIsDeleteConfirmationOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600"
                  onClick={handleDeleteService}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Add Service and Add Category popups */}
        {isAddPopupOpen && <AddServicePopup onClose={AddtogglePopup} />}
        {isAddPopupOpen2 && <AddCategoryPopup onClose={AddtogglePopup2} />}
        {isAddComboOpen && (
          <AddComboPopup 
            onClose={AddComboToggle} 
            services={serviceData} 
          />
        )}
        {/* Edit Service popup */}
        {isEditPopupOpen && (
          <EditServicePopup
            serviceData={editServiceData}
            onClose={EdittogglePopup}
          />
        )}
      </div>
    </>
  );
}

export default ServiceDetails;